import { memo } from 'react';

import type { LbPart } from '../../types';

const MatchEvents = ({ part: { data } }: { part: LbPart }) => (
  <div className='lb-event-text'>
    <p dangerouslySetInnerHTML={{ __html: data.Text }} />
  </div>
);

export default memo(MatchEvents);
